import { VariablesOf } from '@graphql-typed-document-node/core';
import { queryOptions } from '@tanstack/react-query';

import { removeLocale } from 'queries/keys.utils';
import { datoRequester } from 'queries/requesters';
// Bridge query key must match restful/tickets — barrel import would create a cycle.
// eslint-disable-next-line no-restricted-imports
import { TICKETS_PREFIX } from 'restful/tickets/constants';
import { TicketsEventIdByDatoEventSlugDocument } from 'types/api/dato-operations.types';

export const ticketsEventIdByDatoEventSlugQuery = (
  variables: VariablesOf<typeof TicketsEventIdByDatoEventSlugDocument>,
) =>
  queryOptions({
    queryKey: [TICKETS_PREFIX, 'dato-event', removeLocale(variables)],
    queryFn: datoRequester(TicketsEventIdByDatoEventSlugDocument, variables),
  });
